import React from 'react';
import { motion } from 'framer-motion';
import { PackageIcon, CalendarIcon, FileTextIcon, HomeIcon, BarChartIcon, BrainCircuitIcon, MessageCircleIcon } from 'lucide-react';
const items = [{
  icon: CalendarIcon,
  text: '24 sesiones fonoaudiológicas (6 meses completos)'
}, {
  icon: PackageIcon,
  text: 'Actividades listas para usar en sesión'
}, {
  icon: FileTextIcon,
  text: 'Registros clínicos claros'
}, {
  icon: HomeIcon,
  text: 'Tareas para casa'
}, {
  icon: BarChartIcon,
  text: 'Planillas de seguimiento por etapa'
}, {
  icon: BrainCircuitIcon,
  text: 'Adaptaciones para TEA, TDAH, ansiedad y perfiles complejos'
}, {
  icon: MessageCircleIcon,
  text: 'Herramientas para comunicar avances a las familias'
}];
export function IncludesSection() {
  return <section className="py-20 bg-white" data-id="element-41">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-43">
          <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center justify-center gap-3" data-id="element-44">
            <span className="text-4xl" data-id="element-45">📦</span> ¿QUÉ INCLUYE?
          </h2>
          <div className="w-24 h-1 bg-[#C9A84C] mx-auto rounded-full" data-id="element-46" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-47">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4 rounded-lg hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-48">
              <div className="bg-blue-100 p-3 rounded-lg flex-shrink-0" data-id="element-49">
                <item.icon className="w-6 h-6 text-[#1B3A5C]" data-id="element-50" />
              </div>
              <p className="text-lg text-gray-700 font-medium pt-1" data-id="element-51">
                {item.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="mt-12 bg-gray-50 p-6 rounded-xl border-l-4 border-[#C9A84C] text-center" data-id="element-52">
          <p className="text-xl font-bold text-gray-800" data-id="element-53">
            👉 No es un banco de actividades{' '}
            <span className="mx-2 text-gray-400" data-id="element-54">|</span> 👉 No es teoría{' '}
            <span className="mx-2 text-gray-400" data-id="element-55">|</span>{' '}
            <span className="text-[#C9A84C]" data-id="element-56">
              👉 Es un sistema clínico que ordena tu trabajo
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}